/* ==========================================================================
   Ryse - Theoric: frete gratis (topo) + aviso de brinde + RESUMO (rodape)

   >>> ESTE ARQUIVO NAO RECONSTROI NADA. ELE PINTA. <<<
   Ver o cabecalho de theoric-cart-core.js: reconstruir a cada mudanca do
   carrinho era a origem das "piscadas".

   Regra: montar() cria o bloco UMA vez. pintar() atualiza os textos que ja
   estao na tela. Nada de innerHTML depois da montagem.

   DUAS MANEIRAS DE TROCAR UM VALOR, e elas nao sao intercambiaveis:
     rolar()   -> o TOTAL. Protagonista: os digitos deslizam (ver
                  theoric-cart-rolagem.js).
     trocar()  -> Pix, parcelas, frete. Coadjuvantes: um fade de 160ms.
   Se tudo rolar ao mesmo tempo, a gaveta vira caca-niquel e o Total perde o
   destaque - que era justamente o motivo de anima-lo.

   POR QUE O VALOR SAIU DE DENTRO DO BOTAO:
   Preco e informacao para DECIDIR; botao e para AGIR. Valor dentro do botao
   obriga a pessoa a LER O BOTAO para saber quanto vai pagar - e o botao e a
   ultima coisa que ela olha, ja com a mao no gatilho.

   >>> LEIA ANTES DE MEXER NO NUMERO DO FRETE <<<
   O valor vem do painel ("Carrinho Theoric" -> Frete gratis), lido do JSON
   #theoric-cart-config. NAO chumbe numero aqui.
   O valor confirmado para a loja e R$ 319. Se o Frenet nao aplicar isso no
   checkout, a barra promete o que a loja nao cumpre.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = lerConfig();
  if (!cfg) return;

  function lerConfig() {
    var el = document.getElementById('theoric-cart-config');
    if (!el) {
      console.warn('[theoric-cart-extras] #theoric-cart-config ausente.');
      return null;
    }
    try { return JSON.parse(el.textContent); }
    catch (e) { console.error('[theoric-cart-extras] config invalida.', e); return null; }
  }

  var T = window.TheoricCart;
  if (!T) {
    console.error('[theoric-cart-extras] theoric-cart-core.js nao carregou.');
    return;
  }

  var moeda = T.moeda;

  function topo() { return document.querySelector('.theoric__content-scroll'); }
  function rodape() { return document.querySelector('.theoric__footer-inner'); }

  var ICONE_CAMINHAO =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/>' +
    '<path d="M15 18H9M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/>' +
    '<circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';

  var ICONE_CHECK =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>';

  /* --------------------------------------------------------------------------
     ROLAR: para o valor protagonista (o Total). Os digitos que mudaram deslizam;
     os iguais nem se mexem. Se o modulo de rolagem nao carregar, cai no fade -
     uma animacao ausente nao pode impedir o VALOR de aparecer.
     -------------------------------------------------------------------------- */
  function rolar(el, texto) {
    if (window.TheoricRolar) { window.TheoricRolar.trocar(el, texto); return; }
    trocar(el, texto);
  }

  /* --------------------------------------------------------------------------
     TROCAR: para os valores de apoio. Um fade de 160ms de cada lado. O olho le
     como "o valor mudou", nao como "a tela piscou".
     Se o texto nao mudou, nao faz nada: animar por animar tambem cansa.
     -------------------------------------------------------------------------- */
  function trocar(el, texto) {
    if (!el || el.textContent === texto) return;

    el.classList.add('is-trocando');
    setTimeout(function () {
      el.textContent = texto;
      el.classList.remove('is-trocando');
    }, 160);
  }

  /* ==========================================================================
     1. BARRA DE FRETE GRATIS (topo)

     >>> BUG REAL: ELA APARECIA NA BOLSA VAZIA <<<
     Ao remover o ultimo item, a gaveta virava o estado vazio - e a barra
     continuava ali, anunciando "Faltam R$ 319,00 para o frete gratis" para quem
     nao tem nada no carrinho. Uma promessa sem contexto, e uma cobranca sem
     motivo: a pessoa acabou de esvaziar a bolsa, nao precisa de uma meta.
     ========================================================================== */
  function montarFrete() {
    if (!cfg.freteAtivo) return null;
    if (!cfg.freteLimiteCentavos || cfg.freteLimiteCentavos <= 0) return null;

    var alvo = topo();
    if (!alvo) return null;

    var existente = alvo.querySelector('[data-theoric-frete]');
    if (existente) return existente;

    var bloco = document.createElement('div');
    bloco.className = 'theoric-cart-frete';
    bloco.setAttribute('data-theoric-frete', '');
    bloco.innerHTML =
      '<div class="theoric-cart-frete__topo">' +
        '<span class="theoric-cart-frete__icone" data-frete-icone>' + ICONE_CAMINHAO + '</span>' +
        '<p class="theoric-cart-frete__texto" data-frete-texto></p>' +
        '<span class="theoric-cart-frete__alvo" data-frete-alvo></span>' +
      '</div>' +
      '<div class="theoric-cart-frete__trilho" role="progressbar" aria-valuemin="0" aria-valuemax="100"' +
      ' aria-label="Progresso para o frete grátis">' +
        '<div class="theoric-cart-frete__preenchimento" data-frete-barra></div>' +
      '</div>';

    alvo.insertBefore(bloco, alvo.firstChild);
    return bloco;
  }

  function pintarFrete(carrinho) {
    // bolsa vazia: nao ha meta a perseguir. A barra sai.
    if (!carrinho.item_count) {
      var velha = document.querySelector('[data-theoric-frete]');
      if (velha) velha.remove();
      return;
    }

    var bloco = montarFrete();
    if (!bloco) return;

    var limite = cfg.freteLimiteCentavos;
    var total = carrinho.total_price; // ja vem com desconto: e o que se paga
    var falta = Math.max(0, limite - total);
    var completo = falta === 0;
    var pct = Math.min(100, (total / limite) * 100);

    bloco.classList.toggle('is-completo', completo);

    var icone = bloco.querySelector('[data-frete-icone]');
    var texto = bloco.querySelector('[data-frete-texto]');
    var alvo = bloco.querySelector('[data-frete-alvo]');
    var barra = bloco.querySelector('[data-frete-barra]');

    var htmlIcone = completo ? ICONE_CHECK : ICONE_CAMINHAO;
    if (icone.innerHTML.trim() !== htmlIcone.trim()) icone.innerHTML = htmlIcone;

    if (completo) {
      trocar(texto, 'Frete grátis garantido');
      alvo.textContent = '';
    } else {
      // aqui nao da para usar trocar(): ha markup dentro (o <span> do valor)
      var novo = 'Faltam <span class="theoric-cart-frete__valor">' + moeda(falta) +
                 '</span> para o frete grátis';
      if (texto.innerHTML !== novo) texto.innerHTML = novo;
      alvo.textContent = moeda(limite);
    }

    bloco.querySelector('.theoric-cart-frete__trilho')
      .setAttribute('aria-valuenow', Math.round(pct));

    /* A largura tem transition de 700ms no CSS: como o elemento NAO e destruido,
       a barra DESLIZA do valor antigo para o novo. Era isso que a demolicao do
       DOM impedia - ela nascia sempre do zero. */
    barra.style.width = pct + '%';
  }

  /* ==========================================================================
     2. RESUMO (rodape)

     Total          R$ 498,00   -R$ 49,80      <- a conta
                       R$ 448,20               <- o resultado
     R$ 425,79 no Pix -5%     Frete a calcular
     ou 6x de R$ 74,70 sem juros

     >>> A CONTA VEM ANTES DO RESULTADO (Romulo, rodada 6) <<<
     Le-se de cima para baixo como um recibo: era 498, tirou 49,80, sobrou
     448,20. O riscado so cumpre seu papel - fazer o desconto ser SENTIDO, nao
     apenas lido - se estiver ENCOSTADO no numero novo. Numa coluna ao lado, o
     olho nao pareia os dois, e ele vira mais um dado solto.

     E o "Total" fica sempre na MESMA ALTURA: o rotulo alinha pela BASELINE do
     primeiro filho da coluna da direita. Com cupom, esse primeiro filho e a
     linha da economia; sem cupom ela some ([hidden] = display:none, sai do
     fluxo) e o rotulo volta a alinhar com o valor grande. Nenhum numero magico.
     >>> Trocar o [hidden] por opacity/visibility QUEBRA isso. <<<

     >>> O NOME DO CUPOM NAO MORA AQUI - DE PROPOSITO <<<
     "BEMVINDO10" aparecia TRES vezes na gaveta (chip do campo, card do produto
     e resumo). Tres e ruido. O nome fica onde ele e acionavel - no campo, ao
     lado do X que o remove. Aqui fica so o efeito dele no bolso.

     O Pix incide sobre o TOTAL COM DESCONTO. Calcular sobre o valor cheio seria
     inflar o desconto e mentir.
     ========================================================================== */
  function montarResumo() {
    var alvo = rodape();
    if (!alvo) return null;

    var existente = alvo.querySelector('[data-theoric-pay]');
    if (existente) return existente;

    var bloco = document.createElement('div');
    bloco.className = 'theoric-cart-resumo';
    bloco.setAttribute('data-theoric-pay', '');
    bloco.innerHTML =
      '<div class="theoric-cart-resumo__linha">' +
        '<span class="theoric-cart-resumo__rotulo">Total</span>' +
        '<span class="theoric-cart-resumo__num">' +
          '<span class="theoric-cart-resumo__economia" data-resumo-economia hidden>' +
            '<span class="theoric-cart-resumo__antes" data-resumo-antes></span>' +
            '<span class="theoric-cart-resumo__abatido" data-resumo-abatido></span>' +
          '</span>' +
          '<span class="theoric-cart-resumo__valor" data-resumo-total></span>' +
        '</span>' +
      '</div>' +
      '<div class="theoric-cart-resumo__sub">' +
        '<div class="theoric-cart-resumo__esq">' +
          '<span class="theoric-cart-resumo__pix" data-resumo-pix hidden>' +
            '<strong data-resumo-pix-valor></strong> no Pix' +
            '<span class="theoric-cart-resumo__off" data-resumo-off></span>' +
          '</span>' +
          '<p class="theoric-cart-resumo__parcela" data-resumo-parcela hidden></p>' +
        '</div>' +
        '<div class="theoric-cart-resumo__dir">' +
          '<span class="theoric-cart-resumo__frete" data-resumo-frete></span>' +
        '</div>' +
      '</div>';

    var cta = alvo.querySelector('.theoric__footer-cta-row');
    if (cta) alvo.insertBefore(bloco, cta);
    else alvo.appendChild(bloco);

    /* BANDEIRAS - desligadas por ora (painel). O <template> segue no Liquid. */
    if (cfg.mostrarBandeiras) {
      var modelo = document.getElementById('theoric-cart-bandeiras');
      if (modelo && modelo.content && modelo.content.querySelector('svg')) {
        var faixa = document.createElement('div');
        faixa.className = 'theoric-cart-pay__bandeiras';
        faixa.setAttribute('aria-label', 'Formas de pagamento aceitas');
        faixa.appendChild(modelo.content.cloneNode(true));
        bloco.appendChild(faixa);
      }
    }

    return bloco;
  }

  function origemDaLinha(linha) {
    var props = (linha && linha.properties) || {};
    if (props._source === 'Recomendação do Quiz') return 'quiz';
    return 'manual';
  }

  /* A Shopify conhece o preço efetivo do kit, mas os 15% já estão embutidos no
     catálogo e por isso não aparecem em total_discount. Somamos essa economia
     somente à narrativa visual do resumo. O total, Pix, parcelas, frete,
     checkout e integrações continuam usando carrinho.total_price. */
  function economiaEstruturalDosKits(carrinho) {
    var linhas = (carrinho && carrinho.items) || [];
    var usados = {};
    var economiaTotal = 0;
    var cards = document.querySelectorAll(
      'cart-theoric .cart-item--kit[data-kit-reference-unit-price]'
    );

    Array.prototype.forEach.call(cards, function (card) {
      var variante = String(card.dataset.variantId || '');
      var origem = card.dataset.source || 'manual';
      var indice = -1;

      linhas.some(function (linha, i) {
        if (usados[i]) return false;
        if (String(linha.variant_id) !== variante) return false;
        if (origemDaLinha(linha) !== origem) return false;
        indice = i;
        return true;
      });

      if (indice < 0) return;
      usados[indice] = true;

      var linha = linhas[indice];
      var precoAtualUnitario = Number(linha.original_price) || 0;
      var precoReferenciaUnitario = Number(card.dataset.kitReferenceUnitPrice) || 0;

      if (precoReferenciaUnitario <= precoAtualUnitario) {
        precoReferenciaUnitario = Math.round(precoAtualUnitario / 0.85);
      }

      var referenciaDaLinha = precoReferenciaUnitario * (Number(linha.quantity) || 0);
      economiaTotal += Math.max(0, referenciaDaLinha - (Number(linha.original_line_price) || 0));
    });

    return economiaTotal;
  }

  /* --------------------------------------------------------------------------
     Quanto foi abatido, e de quanto era. Inclui tanto descontos Shopify quanto
     a economia estrutural dos kits, que é visual e já está embutida no preço.
     original_total_price nem sempre vem em toda resposta - dai o caminho de
     reserva pela soma. Confiar num campo unico e como confiar num endpoint
     unico: funciona ate o dia em que nao funciona.
     -------------------------------------------------------------------------- */
  function economia(carrinho) {
    var abatidoShopify = carrinho.total_discount || 0;
    var economiaDosKits = economiaEstruturalDosKits(carrinho);

    var antes = carrinho.original_total_price;
    if (typeof antes !== 'number' || antes <= carrinho.total_price) {
      antes = carrinho.total_price + abatidoShopify;
    }

    antes += economiaDosKits;
    var abatido = Math.max(0, antes - carrinho.total_price);
    if (abatido <= 0) return null;

    return { antes: antes, abatido: abatido };
  }

  function pintarResumo(carrinho) {
    if (!carrinho.item_count) return; // bolsa vazia: o tema mostra o convite

    var bloco = montarResumo();
    if (!bloco) return;

    var total = carrinho.total_price;
    var desconto = cfg.pixDesconto || 0;
    var parcelas = cfg.parcelas || 1;
    var limite = cfg.freteLimiteCentavos || 0;

    var noPix = Math.round(total * (100 - desconto) / 100);
    var parcela = Math.floor(total / parcelas);
    var freteGratis = limite > 0 && total >= limite;

    // o protagonista ROLA
    rolar(bloco.querySelector('[data-resumo-total]'), moeda(total));

    /* --- a conta, acima do resultado --- */
    var eco = economia(carrinho);
    var linhaEco = bloco.querySelector('[data-resumo-economia]');

    if (eco) {
      var estavaOculta = linhaEco.hidden;
      linhaEco.hidden = false;
      bloco.querySelector('[data-resumo-antes]').textContent = moeda(eco.antes);
      bloco.querySelector('[data-resumo-abatido]').textContent = '−' + moeda(eco.abatido);

      // anima so quando ELA ACABA DE NASCER - nunca a cada repintura.
      // Re-animar a entrada a cada pintura era, literalmente, a piscada antiga.
      if (estavaOculta) {
        linhaEco.classList.remove('is-novo');
        void linhaEco.offsetWidth;
        linhaEco.classList.add('is-novo');
      }
    } else {
      linhaEco.hidden = true;
      linhaEco.classList.remove('is-novo');
    }

    // os coadjuvantes usam o fade
    var pix = bloco.querySelector('[data-resumo-pix]');
    if (desconto > 0) {
      pix.hidden = false;
      trocar(bloco.querySelector('[data-resumo-pix-valor]'), moeda(noPix));
      bloco.querySelector('[data-resumo-off]').textContent = '-' + desconto + '%';
    } else {
      pix.hidden = true;
    }

    var parc = bloco.querySelector('[data-resumo-parcela]');
    if (parcelas > 1) {
      parc.hidden = false;
      trocar(parc, 'ou ' + parcelas + 'x de ' + moeda(parcela) + ' sem juros');
    } else {
      parc.hidden = true;
    }

    var frete = bloco.querySelector('[data-resumo-frete]');
    frete.classList.toggle('is-gratis', freteGratis);
    trocar(frete, freteGratis ? 'Frete grátis' : 'Frete a calcular');
  }

  /* ========================================================================== */
  T.ao(function (carrinho) {
    if (!carrinho) return;
    pintarFrete(carrinho);
    pintarResumo(carrinho);
  });
})();
